export default __webpack_public_path__ + "static/media/md.e8c9d72d.svg";